import React from 'react';

import { useSelector } from 'react-redux';

import { Select } from 'antd';

import withTranslations from 'app/components/HOGs/withTranslations';

import { PlaceTypes } from 'app/constants/place.constant';
import { useActions } from 'app/components/Utility/hooks/useAction.hooks';

const PlaceCategoryView = () => {
  // const { tr } = props;

  const { PlaceSetCategory } = useActions();

  const category = useSelector((store) => store.placesData.category);
  const fetched = useSelector((store) => store.placesData.fetched);
  const edit = useSelector((store) => store.placesData.isEditMode);

  const GetDefaultOption = () => {
    return {
      value: category,
      label: PlaceTypes[category],
    };
  };

  const GetOption = () => {
    const data = [];

    Object.keys(PlaceTypes).forEach((item) => {
      data.push({
        value: item,
        label: PlaceTypes[item],
      });
    });
    return data;
  };

  if (!fetched) {
    return null;
  }

  if (edit) {
    return (
      <div className="placeCategotyDrop">
        <Select
          defaultValue={GetDefaultOption()}
          onSelect={(val) => PlaceSetCategory(val)}
          size="small"
          style={{ width: 150 }}
          options={GetOption()}
        />
      </div>
    );
  }

  return (
    <div
      style={{
        fontSize: 14,
        display: 'flex',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <span style={{ marginLeft: 3, fontSize: 14 }}>
        {PlaceTypes[category]}
      </span>
    </div>
  );
};

export default withTranslations(PlaceCategoryView);
